export default "/fonts/vendor/lightgallery.js/dist/lg.ttf?a53dcc5ea47fe7d1d9fc881ff489f409";